export enum CustomProductList {
  PromoProductList = 'promoProductList',
  SaleProductList = 'saleProductList',
  SeoProductList = 'seoProductList',
  BestOffersProductList = 'bestOffersProductList',
}

export const customProductList = Object.values(CustomProductList);

export enum DefaultProductList {
  CategoryProductList = 'category',
  SearchResultsProductList = 'search',
}

export const defaultProductList = Object.values(DefaultProductList);
